import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { useAppDispatch, useAppSelector } from '../../../../../redux/hooks';
import Header from './header/Header';
import Files from './files/Files';
import Footer from '../footer/Footer';

// Props type definition
interface ConsultationsProps {
    isMobile: boolean;
}

const Consultations: React.FC<ConsultationsProps> = ({ isMobile }) => {

    const dispatch = useAppDispatch(); 

    const colors = useAppSelector(state => state.theme.colors); 
    const mode = useAppSelector(state => state.fileExplorer.mode); 

    // Define width and height based on isMobile prop (similar to FilesSection)
    const width = isMobile ? '95%' : '73%'; 
    const height = isMobile ? 'auto' : '95%'; 
    const flexGrow = isMobile ? 1 : undefined;
    const margin = isMobile ? 1 : 1; 
    const padding = isMobile ? 1 : 0;

    return (

        <Box       
        sx={{ 
            display: 'flex', 
            flexDirection: 'column',
            alignItems: 'center', 
            width: width,
            height: height, 
            flexGrow: flexGrow,
            minHeight: 0, 
            borderRadius: isMobile ? 1 : 2,
            backgroundColor: colors?.container,
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
            margin: margin,
            padding: padding,
            overflow: 'hidden',
        }}>

            <Header /> 

            <Files /> 

            <Footer /> 

        </Box>

    );

};

export default Consultations;